import {handleActions} from 'redux-actions';
import {Record, Map} from 'immutable';

import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';

import * as Actions from './actions';

const State = Record({
    editingDiscounts: Map(),
});

export default handleActions(
    {
        [ManagePlanActions.showCreatePlan.type]: () => {
            return new State();
        },

        [ManagePlanActions.insertPlan.type]: () => new State(),
        [ManagePlanActions.showEditPlan.type]: () => new State(),

        [ManagePlanActions.createPlanSuccess.type]: () => new State(),
        [ManagePlanActions.updatePlanSuccess.type]: () => new State(),

        [Actions.discountDidChange.type]: (state, {payload}) =>
            state.merge({
                editingDiscounts: state.editingDiscounts.set(payload.discountId, payload.newDiscount),
            }),

        [Actions.convertToPercentage.type]: (state, {payload}) =>
            state.merge({
                editingDiscounts: state.editingDiscounts.delete(payload.discountId),
            }),

        [ManagePlanActions.setBillingProfile.type]: (state, {payload}) => {
            const {billingProfile} = payload;
            if (!billingProfile) {
                return state;
            }

            return state.merge({
                editingDiscounts: Map(),
            });
        },

        [ManagePlanActions.closeManagePlan.type]: () => {
            return new State();
        },
    },
    new State(),
);
